/**
 * product-gallery-dots.js
 * ---------------------------------------------------------------------------
 * Pontinhos (dots) de paginação da galeria de fotos da PDP, no mobile —
 * igual à Pink. O arraste com o dedo já é nativo (a lista é um `.slider`
 * com scroll-snap); isso aqui só cuida de:
 *  - marcar o dot ativo conforme o usuário arrasta/rola a lista
 *  - pular direto pra uma foto ao tocar num dot
 * Sem dependências, mesmo espírito do vitrine-tabs.js / product-tabs.js.
 * ---------------------------------------------------------------------------
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-gallery-dots').forEach(function (dotsWrap) {
    const sliderComponent = dotsWrap.closest('slider-component');
    if (!sliderComponent) return;

    const track = sliderComponent.querySelector('.product__media-list');
    if (!track) return;

    const items = Array.from(track.children).filter(function (el) {
      return el.tagName === 'LI';
    });
    const dots = Array.from(dotsWrap.querySelectorAll('.product-gallery-dots__dot'));
    if (!items.length || !dots.length) return;

    function closestIndex() {
      let closest = 0;
      let closestDistance = Infinity;
      items.forEach(function (item, index) {
        const distance = Math.abs(item.offsetLeft - track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = index;
        }
      });
      return closest;
    }

    function setActive(index) {
      dots.forEach(function (dot, i) {
        const isActive = i === index;
        dot.classList.toggle('active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    let scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        setActive(closestIndex());
      }, 100);
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: items[index].offsetLeft, behavior: 'smooth' });
        setActive(index);
      });
    });
  });
});